// extracted by mini-css-extract-plugin
module.exports = {"statusContainer":"profileStatusButtons_statusContainer__2sOMI","toggle":"profileStatusButtons_toggle__1712t","toggleSwitch":"profileStatusButtons_toggleSwitch__1wIg7"};